/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AzureManagementGroup } from '../models/AzureManagementGroup';
import { AzureTenant } from '../models/AzureTenant';

export class AzureManagementGroups {
  'tenants'?: Array<AzureTenant>;
  'managementGroups': Array<AzureManagementGroup>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "tenants",
      "baseName": "tenants",
      "type": "Array<AzureTenant>",
      "format": ""
    },
    {
      "name": "managementGroups",
      "baseName": "managementGroups",
      "type": "Array<AzureManagementGroup>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureManagementGroups.attributeTypeMap;
  }

  public constructor() {
  }
}

